import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

import { Field } from '../../models/field.interface';
import { FieldConfig } from '../../models/field-config.interface';
import { TranslateService } from '@ngx-translate/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-form-toggle',
    templateUrl: './form-toggle.component.html',
    styleUrls: ['form-toggle.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass, ReactiveFormsModule]
})
export class FormtoggleComponent implements Field, OnInit, AfterViewInit {
  config: FieldConfig;
  group: FormGroup;
  yes: string;
  no: string;

  constructor(private ts: TranslateService) {

  }

  ngOnInit() {
    console.log(this.config);
    const _that = this;
    this.yes = this.ts.instant('Requisition.yes') + ' ';
    this.no = this.ts.instant('Requisition.no');

    _that.group.controls[_that.config.name].valueChanges.subscribe(val => {
      _that.config.value = val;
      _that.calculateWidth();
    });
  }

  toggleChange(event) {
    this.config.changeEvent(event);
  }


  ngAfterViewInit() {
    const element = document.getElementsByClassName(this.config.name)[0];
    if (element) {
      element.setAttribute('data-on', this.yes);
      element.setAttribute('data-off', this.no);
    }
    this.calculateWidth();


  }

  calculateWidth() {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    context.font = '12px Roboto-Regular';
    const metrics = context.measureText(this.yes);
    if (canvas) {
      canvas.remove();
    }
    const switchEle = document.getElementsByClassName(this.config.name)[0];
    if(switchEle['offsetParent']['style']['left']) {
      switchEle['offsetParent']['style']['width'] = (Math.ceil(metrics.width) + 30) + 'px';
      const nextSibling = switchEle['nextSibling'];
      if (nextSibling && nextSibling['style']) {
        if (this.config.value) {
          nextSibling['style']['left'] = (Math.ceil(metrics.width) + 10) + 'px';
        } else {
          nextSibling['style']['left'] = '6px';
        }
      }
    }
    }

}
